import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {


  @Input('page') page:any;

  constructor(public cm:CommonService) { 
    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu'){
        if(massage.text == 'true'){
          this.isShowMenu = true;
        }else {
          this.isShowMenu = false;
        }
      }
    })
  }

  ngOnInit() {
  }

  changePage(cPage){
    if(!(cPage == this.page)){
      this.cm.goto(cPage);
    }
  }

  logout(){
    this.cm.afAuth.auth.signOut().then((data)=>{
      localStorage.clear();
      this.cm.toastr.success('ออกจากระบบ','สำเร็จ');
      this.cm.goto('login');
    })
    
  }

  isShowMenu = true;
  hideMenu(){
    this.isShowMenu = false;
  }

  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu2',String(this.isShowMenu));
  }

}
